import { useState } from "react";
import SportsContractCardsDemo from "../../SportsContractCardsDemo";
import EndorsementCardsDemo from "../../EndorsementCardsDemo";

const TABS = [
    { id: "recording",    label: "🎵 Recording Deal",    sub: "Midnight Records × Alexandra Rivers · $420K" },
    { id: "endorsement",  label: "⚡ Endorsement Deal",  sub: "SportsDrinkCo × Athlete · $180K"            },
] as const;

type TabId = typeof TABS[number]["id"];

export function RamVizPage() {
    const [active, setActive] = useState<TabId>("recording");

    return (
        <div className="min-h-screen text-white" style={{ background: "radial-gradient(circle at top left, rgba(92,61,255,0.18), transparent 30%), radial-gradient(circle at top right, rgba(63,116,255,0.15), transparent 25%), linear-gradient(180deg,#06070b 0%,#0b0d14 100%)" }}>
            {/* Header */}
            <div className="sticky top-0 z-20 border-b border-white/8 bg-[#111113]/90 backdrop-blur-md px-4 py-3">
                <div className="mb-3">
                    <div className="text-[10px] font-bold uppercase tracking-widest text-white/30">Equal-IQ</div>
                    <h1 className="text-base font-bold text-white">Contract Intelligence Cards — Demo</h1>
                </div>
                {/* Tab switcher */}
                <div className="flex gap-2">
                    {TABS.map(tab => (
                        <button
                            key={tab.id}
                            onClick={() => setActive(tab.id)}
                            className={`flex-1 rounded-2xl border px-3 py-2.5 text-left transition-all duration-200 ${
                                active === tab.id
                                    ? "border-[#547bb5]/50 bg-gradient-to-r from-[#547bb5]/20 to-[#6e53b8]/20 text-white"
                                    : "border-white/8 bg-white/3 text-white/40 hover:bg-white/6 hover:text-white/70"
                            }`}
                        >
                            <div className="text-sm font-semibold">{tab.label}</div>
                            <div className="mt-0.5 text-[10px] text-white/35">{tab.sub}</div>
                        </button>
                    ))}
                </div>
            </div>

            {/* Content */}
            <div className="p-4">
                {active === "recording" ? (
                    <SportsContractCardsDemo />
                ) : (
                    <EndorsementCardsDemo />
                )}
            </div>
        </div>
    );
}
